import { render, staticRenderFns } from "./EnterpriseRowMobile.vue?vue&type=template&id=2670bb05&scoped=true&"
import script from "./EnterpriseRowMobile.vue?vue&type=script&lang=ts&"
export * from "./EnterpriseRowMobile.vue?vue&type=script&lang=ts&"
import style0 from "./EnterpriseRowMobile.vue?vue&type=style&index=0&id=2670bb05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670bb05",
  null
  
)

export default component.exports